(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function ensureLiveRegion() {
    var region = document.getElementById('A11yStatus');
    if (region) return region;
    region = document.createElement('div');
    region.id = 'A11yStatus';
    region.className = 'visually-hidden';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
  }

  function announce(message) {
    var region = ensureLiveRegion();
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 30);
  }

  function closestQuantityInput(control) {
    var controlsId = control.getAttribute('aria-controls');
    if (controlsId) {
      var controlled = document.getElementById(controlsId);
      if (controlled) return controlled;
    }
    var wrapper = control.closest('.js-qty__wrapper');
    return wrapper ? wrapper.querySelector('.js-qty__num') : null;
  }

  function rememberFocus(element) {
    if (!element || !element.id) return;
    try {
      sessionStorage.setItem('a11yRestoreFocusId', element.id);
    } catch (error) {}
  }

  function restoreFocus() {
    var focusId = null;
    var restoreScrollY = null;
    try {
      focusId = sessionStorage.getItem('a11yRestoreFocusId');
      restoreScrollY = sessionStorage.getItem('a11yRestoreScrollY');
      sessionStorage.removeItem('a11yRestoreFocusId');
      sessionStorage.removeItem('a11yRestoreScrollY');
    } catch (error) {}
    if (!focusId) return;
    window.setTimeout(function () {
      var element = document.getElementById(focusId);
      if (element) {
        var scrollY = restoreScrollY === null ? null : Number(restoreScrollY);
        var preserveScroll = scrollY !== null && Number.isFinite(scrollY) && scrollY >= 0;
        if (preserveScroll) window.scrollTo(0, scrollY);
        element.focus({ preventScroll: preserveScroll });
        if (preserveScroll) {
          window.requestAnimationFrame(function () {
            window.scrollTo(0, scrollY);
          });
          window.setTimeout(function () {
            window.scrollTo(0, scrollY);
          }, 350);
        }
        if (element.classList.contains('js-qty__num')) {
          announce('Quantity updated to ' + element.value + '.');
        }
      }
    }, 250);
  }

  function updateQuantityStatus(input) {
    if (!input) return;
    var wrapper = input.closest('.js-qty__wrapper');
    var status = wrapper ? wrapper.querySelector('[data-a11y-quantity-status]') : null;
    var message = 'Quantity updated to ' + input.value + '.';
    if (status) status.textContent = message;
    announce(message);
  }

  document.addEventListener('click', function (event) {
    var variantBtn = event.target.closest('.grid-product__variant');
    if (!variantBtn || variantBtn.hasAttribute('disabled')) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = variantBtn.getAttribute('data-variant-id');
    var variantPrice = variantBtn.getAttribute('data-variant-price');
    var gridItem = variantBtn.closest('.grid-product');
    if (!gridItem) return;

    var addButton = gridItem.querySelector('.js-quick-add-btn');
    var activeVariant = gridItem.querySelector('.grid-product__variant.active');

    if (activeVariant) {
      activeVariant.classList.remove('active');
      activeVariant.setAttribute('aria-checked', 'false');
      activeVariant.setAttribute('tabindex', '-1');
    }
    variantBtn.classList.add('active');
    variantBtn.setAttribute('aria-checked', 'true');
    variantBtn.setAttribute('tabindex', '0');

    if (addButton) {
      addButton.setAttribute('data-id', variantId);
      var addButtonPrice = addButton.querySelector('.grid-product__price');
      if (addButtonPrice) addButtonPrice.innerText = variantPrice;
      updateVisibleName(addButton);
    }

    var primaryImg = gridItem.querySelector('[data-product-card-primary-img]');
    var primaryWrap = primaryImg ? primaryImg.closest('[data-default-src]') : null;
    var defaultSrc = primaryWrap ? primaryWrap.getAttribute('data-default-src') : null;
    var newSrc = defaultSrc;

    if (primaryImg && newSrc) {
      requestAnimationFrame(function () {
        primaryImg.setAttribute('data-src', newSrc);
        primaryImg.setAttribute('src', newSrc);
        primaryImg.setAttribute('srcset', newSrc);
        primaryImg.setAttribute('data-srcset', newSrc);
        primaryImg.classList.remove('lazyload');
        primaryImg.classList.add('lazyloaded');
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    var radio = event.target.closest('.grid-product__variant[role="radio"]');
    if (radio && ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'].indexOf(event.key) !== -1) {
      var group = radio.closest('[role="radiogroup"]');
      if (!group) return;
      var radios = Array.prototype.slice.call(group.querySelectorAll('.grid-product__variant[role="radio"]:not([disabled])'));
      var index = radios.indexOf(radio);
      if (index === -1) return;
      event.preventDefault();
      var offset = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
      var next = radios[(index + offset + radios.length) % radios.length];
      next.focus();
      next.click();
    }

    var quantityInput = event.target.closest('.js-qty__num');
    if (quantityInput && event.key === 'Enter') {
      rememberFocus(quantityInput);
      if (quantityInput.closest('.cart__drawer-form')) {
        event.preventDefault();
        updateQuantityStatus(quantityInput);
      }
    }
  });

  document.addEventListener('click', function (event) {
    var quantityControl = event.target.closest('.js-qty__adjust');
    if (!quantityControl) return;
    var input = closestQuantityInput(quantityControl);
    rememberFocus(input);
    window.setTimeout(function () {
      updateQuantityStatus(input);
    }, 250);
  });

  document.addEventListener('change', function (event) {
    var quantityInput = event.target.closest('.js-qty__num');
    if (quantityInput) {
      rememberFocus(quantityInput);
      updateQuantityStatus(quantityInput);
    }

    if (event.target && event.target.id === 'SortBy') {
      rememberFocus(event.target);
      try {
        sessionStorage.setItem('a11ySortChanged', event.target.options[event.target.selectedIndex].text);
        sessionStorage.setItem('a11yRestoreScrollY', String(window.scrollY));
      } catch (error) {}
    }
  }, true);

  document.addEventListener('click', function (event) {
    var sortButton = event.target.closest('.filter-sort');
    if (!sortButton) return;
    try {
      sessionStorage.setItem('a11yRestoreFocusId', 'SortBy');
      sessionStorage.setItem('a11ySortChanged', sortButton.textContent.trim());
      sessionStorage.setItem('a11yRestoreScrollY', String(window.scrollY));
    } catch (error) {}
  }, true);

  function enhanceVideoButtons() {
    // Live DOM (per QA recon 2026-06-29) uses button#VideoOverlay-...[aria-label="Play video"],
    // not always .video-play-overlay, so match both the class and the labeled/id variants.
    var videoButtons = document.querySelectorAll(
      'button.video-play-overlay, button[id^="VideoOverlay"], button[aria-label="Play video"], button[aria-label="Pause video"]'
    );
    videoButtons.forEach(function (button) {
      if (button.dataset.a11yVideoEnhanced === 'true') return;
      button.dataset.a11yVideoEnhanced = 'true';
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Play video');

      var container = button.closest('.product__media, .hero-video, .video-parent, .image-wrap, .media, section') || document;
      var video = container.querySelector('video') || document.querySelector('video');
      if (!video) {
        button.setAttribute('aria-pressed', 'false');
        return;
      }

      function syncVideoState(shouldAnnounce) {
        var playing = !video.paused && !video.ended;
        button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        button.setAttribute('aria-pressed', playing ? 'true' : 'false');
        if (shouldAnnounce) announce(playing ? 'Video playing.' : 'Video paused.');
      }

      video.addEventListener('play', function () {
        syncVideoState(true);
      });
      video.addEventListener('pause', function () {
        syncVideoState(true);
      });
      video.addEventListener('ended', function () {
        syncVideoState(false);
      });
      syncVideoState(false);
    });
  }

  function syncStampedRating(rating) {
    var stars = Array.prototype.slice.call(rating.querySelectorAll('a'));
    if (!stars.length) return;
    var input = rating.closest('.stamped-form-review-rating');
    input = input ? input.querySelector('input[name="reviewRating"]') : null;
    var selectedValue = input ? String(input.value || '') : '';
    var selectedStar = null;

    stars.forEach(function (star, index) {
      var starValue = star.getAttribute('data-value') || String(index + 1);
      var selected = selectedValue !== '' && starValue === selectedValue;
      star.setAttribute('role', 'radio');
      star.removeAttribute('aria-pressed');
      star.setAttribute('aria-label', starValue + (starValue === '1' ? ' star' : ' stars'));
      star.setAttribute('aria-checked', selected ? 'true' : 'false');
      if (selected) selectedStar = star;
    });

    stars.forEach(function (star, index) {
      star.setAttribute('tabindex', star === selectedStar || (!selectedStar && index === 0) ? '0' : '-1');
    });
  }

  function syncStampedTabs(tabs, activeTab, tabListIndex) {
    tabs.forEach(function (tab, index) {
      var selected = tab === activeTab;
      var tabType = tab.getAttribute('data-type') || (index === 0 ? 'reviews' : 'questions');
      var panelId = tab.getAttribute('aria-controls') || 'stamped-' + tabType + '-tab';
      var panel = document.getElementById(panelId);

      if (!tab.id) tab.id = 'stamped-tab-' + tabType + '-' + tabListIndex + '-' + index;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (panel) {
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.hidden = !selected;
      }
    });
  }

  function removeInvalidStampedReviewFormExpandedState(root) {
    if (!root) return;
    if (root.matches && root.matches('.new-review-form[aria-expanded]')) {
      root.removeAttribute('aria-expanded');
    }
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.new-review-form[aria-expanded]').forEach(function (reviewForm) {
      reviewForm.removeAttribute('aria-expanded');
    });
  }

  function observeStampedReviewFormExpandedState() {
    if (window.__simplyGumStampedReviewFormExpandedObserver) return;
    window.__simplyGumStampedReviewFormExpandedObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var reviewForm = mutation.target;
        if (
          reviewForm.matches &&
          reviewForm.matches('.new-review-form[aria-expanded]')
        ) {
          reviewForm.removeAttribute('aria-expanded');
        }
      });
    });
    window.__simplyGumStampedReviewFormExpandedObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
      subtree: true
    });
  }

  function enhanceStampedWidgets() {
    removeInvalidStampedReviewFormExpandedState(document);

    document.querySelectorAll('.stamped-form-review-rating .stamped-starrating').forEach(function (rating) {
      rating.setAttribute('role', 'radiogroup');
      if (!rating.getAttribute('aria-label')) rating.setAttribute('aria-label', 'Rating');
      syncStampedRating(rating);
    });

    document.querySelectorAll('.stamped-form-review-rating .stamped-starrating a').forEach(function (star) {
      if (star.dataset.a11yRatingEnhanced === 'true') return;
      star.dataset.a11yRatingEnhanced = 'true';
      star.addEventListener('keydown', function (event) {
        if ([' ', 'Enter'].indexOf(event.key) !== -1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          star.click();
          window.setTimeout(function () {
            syncStampedRating(star.closest('.stamped-starrating'));
          }, 0);
        }
        if (['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'].indexOf(event.key) !== -1) {
          var group = star.closest('.stamped-starrating');
          var stars = Array.prototype.slice.call(group.querySelectorAll('a'));
          var index = stars.indexOf(star);
          var offset = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
          var next = stars[(index + offset + stars.length) % stars.length];
          event.preventDefault();
          event.stopImmediatePropagation();
          next.click();
          next.focus();
          window.setTimeout(function () {
            syncStampedRating(group);
            next.focus();
          }, 0);
        }
      }, true);
      star.addEventListener('click', function () {
        window.setTimeout(function () {
          syncStampedRating(star.closest('.stamped-starrating'));
        }, 0);
      });
    });

    document.querySelectorAll('.stamped-tabs').forEach(function (tabList, tabListIndex) {
      var tabCandidates = Array.prototype.slice.call(tabList.children).map(function (child) {
        if (child.matches('[role="tab"], a, button, .stamped-tab')) return child;
        return child.querySelector(':scope > [role="tab"], :scope > a, :scope > button, :scope > .stamped-tab') || child;
      });
      if (tabCandidates.length < 2) return;

      tabList.setAttribute('role', 'tablist');
      var activeTab = tabCandidates.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true' || tab.classList.contains('active');
      }) || tabCandidates[0];
      syncStampedTabs(tabCandidates, activeTab, tabListIndex);

      tabCandidates.forEach(function (tab, index) {
        if (tab.dataset.a11yTabEnhanced === 'true') return;
        tab.dataset.a11yTabEnhanced = 'true';
        tab.addEventListener('keydown', function (event) {
          var targetIndex = null;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            targetIndex = (index - 1 + tabCandidates.length) % tabCandidates.length;
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            targetIndex = (index + 1) % tabCandidates.length;
          } else if (event.key === 'Home') {
            targetIndex = 0;
          } else if (event.key === 'End') {
            targetIndex = tabCandidates.length - 1;
          } else if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            tab.click();
            return;
          }
          if (targetIndex === null) return;
          event.preventDefault();
          tabCandidates[targetIndex].focus();
        });
        tab.addEventListener('click', function () {
          window.setTimeout(function () {
            syncStampedTabs(tabCandidates, tab, tabListIndex);
          }, 0);
        });
      });
    });
  }

  function enhanceWishlistFallback() {
    document.querySelectorAll('a[href="#swym-wishlist"]').forEach(function (link) {
      if (link.dataset.a11yWishlistEnhanced === 'true') return;
      link.dataset.a11yWishlistEnhanced = 'true';
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Open wishlist');
      // WCAG 2.4.4: a bare "#swym-wishlist" fragment is not a valid destination.
      // Swym renders a real page at /swym-wishlist, so upgrade the href to that page.
      // This keeps the link valid even with JS disabled or the modal launcher absent.
      link.setAttribute('href', '/swym-wishlist');
      link.addEventListener('click', function (event) {
        var launcher = document.querySelector('.swym-wishlist, [data-swym-wishlist], .swym-button');
        if (!launcher || launcher === link) return; // fall through to /swym-wishlist navigation
        event.preventDefault();
        launcher.click();
        window.setTimeout(function () {
          var dialog = document.querySelector('[role="dialog"], .swym-ui-component, .swym-modal');
          if (dialog) {
            dialog.setAttribute('tabindex', '-1');
            dialog.focus();
          }
        }, 300);
      });
    });
  }

  function getFocusableElements(container) {
    if (!container) return [];
    var selector = [
      'a[href]:not([tabindex="-1"])',
      'button:not([disabled]):not([tabindex="-1"])',
      'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
      'select:not([disabled]):not([tabindex="-1"])',
      'textarea:not([disabled]):not([tabindex="-1"])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.prototype.slice.call(container.querySelectorAll(selector)).filter(function (element) {
      return element.offsetParent !== null || element === document.activeElement;
    });
  }

  function enhanceCartDrawerFocus() {
    var drawer = document.getElementById('HeaderCart');
    if (!drawer || drawer.dataset.a11yCartFocusEnhanced === 'true') return;
    drawer.dataset.a11yCartFocusEnhanced = 'true';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.getAttribute('aria-labelledby')) drawer.setAttribute('aria-label', 'Your Cart');

    var trigger = document.getElementById('HeaderCartTrigger');
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', drawer.getAttribute('aria-hidden') === 'false' ? 'true' : 'false');
      trigger.addEventListener('click', function () {
        window.a11yCartTrigger = trigger;
      });
    }

    function findCloseButton() {
      var candidates = Array.prototype.slice.call(drawer.querySelectorAll('.js-close-header-cart, button, a[href]'));
      return candidates.find(function (candidate) {
        var label = (candidate.getAttribute('aria-label') || candidate.textContent || '').toLowerCase();
        return candidate.classList.contains('js-close-header-cart') || label.indexOf('close') !== -1;
      });
    }

    function focusDrawer() {
      var closeButton = findCloseButton();
      var focusables = getFocusableElements(drawer);
      var target = closeButton || focusables[0] || drawer;
      if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
      window.setTimeout(function () {
        if (target && drawer.contains(target)) {
          target.focus({ preventScroll: true });
          announce('Cart opened.');
        }
      }, 80);
    }

    function syncState() {
      var isOpen = drawer.getAttribute('aria-hidden') === 'false';
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen && drawer.dataset.a11yCartWasOpen !== 'true') {
        drawer.dataset.a11yCartWasOpen = 'true';
        focusDrawer();
      }
      if (!isOpen && drawer.dataset.a11yCartWasOpen === 'true') {
        drawer.dataset.a11yCartWasOpen = 'false';
        var previousTrigger = window.a11yCartTrigger || trigger;
        if (previousTrigger && document.body.contains(previousTrigger)) {
          window.setTimeout(function () {
            previousTrigger.focus({ preventScroll: true });
          }, 80);
        }
      }
    }

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var closeButton = findCloseButton();
        if (closeButton) closeButton.click();
        return;
      }
      if (event.key !== 'Tab' || drawer.getAttribute('aria-hidden') === 'true') return;
      var focusables = getFocusableElements(drawer);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var observer = new MutationObserver(syncState);
    observer.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'style'] });
    syncState();
  }

  function enhanceCartLinkLabel() {
    var trigger = document.getElementById('HeaderCartTrigger');
    if (!trigger) return;
    var countElement = trigger.querySelector('.cart-link__bubble-num');
    var rawCount = countElement ? countElement.textContent.replace(/\D+/g, '') : '';
    var itemCount = rawCount ? parseInt(rawCount, 10) : 0;
    trigger.setAttribute('aria-label', 'Shopping cart with ' + itemCount + (itemCount === 1 ? ' item' : ' items'));
    if (countElement) countElement.setAttribute('aria-hidden', 'true');
  }

  function enhanceSearchComboboxes() {
    document.querySelectorAll('.site-header__search-input, input[type="search"][name="q"]').forEach(function (input) {
      var results = document.getElementById('SearchResultsWrapper');
      var predictive = document.getElementById('PredictiveResults');
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-haspopup', 'listbox');
      input.setAttribute('aria-controls', predictive ? 'SearchResultsWrapper PredictiveResults' : 'SearchResultsWrapper');
      input.setAttribute('aria-expanded', results && !results.classList.contains('hide') ? 'true' : 'false');
      input.setAttribute('autocomplete', 'off');
    });
  }

  function scheduleSearchComboboxRepair() {
    [0, 250, 1000, 2500, 5000, 9000].forEach(function (delay) {
      window.setTimeout(enhanceSearchComboboxes, delay);
    });
  }

  function enhanceProductCardActions() {
    document.querySelectorAll('.js-quick-add-btn, .quick-product__btn').forEach(function (button) {
      if (button.getAttribute('tabindex') === '-1') button.removeAttribute('tabindex');
      updateVisibleName(button);
    });

    document.querySelectorAll('.grid-product__variants[role="radiogroup"]').forEach(function (group) {
      var radios = Array.prototype.slice.call(group.querySelectorAll('.grid-product__variant[role="radio"]'));
      var availableRadios = radios.filter(function (radio) {
        return !radio.hasAttribute('disabled');
      });
      availableRadios.forEach(function (radio, index) {
        radio.setAttribute('aria-posinset', String(index + 1));
        radio.setAttribute('aria-setsize', String(availableRadios.length));
        if (!radio.hasAttribute('aria-checked')) {
          radio.setAttribute('aria-checked', radio.classList.contains('active') ? 'true' : 'false');
        }
      });
    });
  }

  function findNavigationLandmarkTarget(navigation) {
    var wrapper = navigation.parentElement;
    while (wrapper && wrapper !== document.body && wrapper !== document.documentElement) {
      var tagName = wrapper.tagName.toLowerCase();
      var wrapperRole = wrapper.getAttribute('role');
      if (tagName === 'nav') return wrapper;
      if (['ul', 'ol', 'li', 'header', 'main', 'footer', 'aside'].indexOf(tagName) === -1 && (!wrapperRole || wrapperRole === 'navigation')) {
        return wrapper;
      }
      wrapper = wrapper.parentElement;
    }
    return null;
  }

  function enhanceLandmarks() {
    document.querySelectorAll('.site-navigation').forEach(function (navigation, index) {
      var tagName = navigation.tagName.toLowerCase();
      var navigationLabel = navigation.getAttribute('aria-label') || (index === 0 ? 'Primary navigation' : 'Secondary navigation');
      if (tagName === 'ul' || tagName === 'ol') {
        if (navigation.getAttribute('role') === 'navigation') navigation.removeAttribute('role');
        var landmark = findNavigationLandmarkTarget(navigation);
        if (landmark) {
          if (landmark.tagName.toLowerCase() !== 'nav' && !landmark.getAttribute('role')) {
            landmark.setAttribute('role', 'navigation');
          }
          if (!landmark.getAttribute('aria-label')) landmark.setAttribute('aria-label', navigationLabel);
          if (navigation.hasAttribute('aria-label')) navigation.removeAttribute('aria-label');
        }
        return;
      }
      if (tagName !== 'nav' && !navigation.getAttribute('role')) {
        navigation.setAttribute('role', 'navigation');
      }
      if (!navigation.getAttribute('aria-label')) {
        navigation.setAttribute('aria-label', navigationLabel);
      }
    });
    document.querySelectorAll('.site-nav__icons').forEach(function (icons) {
      var wrapper = icons.closest('nav, [role="navigation"]');
      if (!wrapper) {
        icons.setAttribute('role', 'navigation');
        icons.setAttribute('aria-label', 'Utility navigation');
      }
    });
    document.querySelectorAll('.grid-article').forEach(function (articleCard) {
      if (articleCard.tagName.toLowerCase() !== 'article' && !articleCard.getAttribute('role')) {
        articleCard.setAttribute('role', 'article');
      }
    });
  }

  function enhanceProductMediaAlts() {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-product-thumb] img, .product__thumb img'));
    if (!thumbs.length) return;
    var total = thumbs.length;
    var seen = {};
    thumbs.forEach(function (image, index) {
      var originalAlt = (image.getAttribute('alt') || '').trim();
      var altText = originalAlt;
      if (!altText || altText === '&' || /&$/.test(altText)) {
        var productTitle = document.querySelector('h1, .product-single__title, [data-product-title]');
        var titleText = productTitle ? productTitle.textContent.trim() : 'Product';
        altText = titleText + ' image';
      }
      var normalized = altText.toLowerCase();
      seen[normalized] = (seen[normalized] || 0) + 1;
      if (seen[normalized] > 1 || !originalAlt || altText !== originalAlt) {
        altText = altText.replace(/\s+/g, ' ') + ' ' + (index + 1) + ' of ' + total;
        image.setAttribute('alt', altText);
      }
    });
  }

  function getVisibleText(element) {
    if (!element) return '';
    var clone = element.cloneNode(true);
    clone.querySelectorAll('svg, style, script, .visually-hidden, .icon__fallback-text').forEach(function (hidden) {
      hidden.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function getProductTitle(element) {
    var productCard = element.closest('.grid-product, .grid-item, .cart__item, .product-single__meta');
    var titleElement = productCard ? productCard.querySelector('.grid-product__title, [id^="ProductCardTitle"], .cart__item-name, h1') : null;
    return titleElement ? titleElement.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function updateVisibleName(element) {
    var visibleText = getVisibleText(element);
    if (!visibleText) return;
    var productTitle = getProductTitle(element);
    var label = visibleText;
    if (productTitle && label.toLowerCase().indexOf(productTitle.toLowerCase()) === -1) {
      label += ' - ' + productTitle;
    }
    element.setAttribute('aria-label', label);
  }

  function enhanceAccessibleNames() {
    document.querySelectorAll('.js-quick-add-btn, .add-to-cart, button[aria-label], a[aria-label]').forEach(function (element) {
      if (element.matches('.grid-product__variant')) return;
      if (element.matches('button.video-play-overlay, button[id^="VideoOverlay"]')) return;
      var visibleText = getVisibleText(element);
      var currentLabel = element.getAttribute('aria-label') || '';
      if (!visibleText || !currentLabel) return;
      if (currentLabel.toLowerCase().indexOf(visibleText.toLowerCase()) !== 0) {
        updateVisibleName(element);
      }
    });
  }

  function humanizePathSegment(segment) {
    if (!segment) return '';
    return segment
      .split('?')[0]
      .split('#')[0]
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); })
      .trim();
  }

  function pageLabelFromLocation() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (!path || path === '') return 'Simply Gum Natural Chewing Gum, Mints, Chocolates, and Fruit Bites';
    if (path.indexOf('/tools/recurring') === 0) {
      if (path.indexOf('/login') !== -1) return 'Subscription Login';
      if (path.indexOf('/payment-methods') !== -1) return 'Subscription Payment Methods';
      if (path.indexOf('/cancel') !== -1) return 'Cancel Subscription';
      if (path.indexOf('/overview') !== -1 || path.indexOf('/portal') !== -1) return 'Subscription Account Overview';
      if (path.indexOf('/get-subscription-access') !== -1) return 'Get Subscription Access';
      return 'Subscription Account';
    }
    var parts = path.split('/').filter(Boolean);
    if (parts[0] === 'collections' && parts.length === 1) return 'All Collections';
    if (parts[0] === 'collections' && parts.length === 2) return humanizePathSegment(parts[1]) + ' Collection';
    if (parts[0] === 'collections' && parts.indexOf('products') !== -1) return humanizePathSegment(parts[parts.length - 1]);
    if (parts[0] === 'products') return humanizePathSegment(parts[1]);
    if (parts[0] === 'pages') return humanizePathSegment(parts[1]);
    if (parts[0] === 'account') return parts[1] === 'login' ? 'Account Login' : 'Account';
    if (parts[0] === 'cart') return 'Cart';
    if (parts[0] === 'search') return 'Search';
    return humanizePathSegment(parts[parts.length - 1]) || 'Simply Gum';
  }

  function enhancePageTitle() {
    var pageLabel = pageLabelFromLocation();
    var currentTitle = (document.title || '').replace(/\s+/g, ' ').trim();
    var generic = !currentTitle || currentTitle === 'Simply Gum' || currentTitle === 'Simply Gum Natural Chewing Gum, Mints, Chocolates, and Fruit Bites';
    if (generic || currentTitle.length < 14 || currentTitle.indexOf('&ndash;') !== -1) {
      document.title = pageLabel.indexOf('Simply Gum') !== -1 ? pageLabel : pageLabel + ' - Simply Gum';
    }
  }

  function ensureElementId(element, prefix) {
    if (element.id) return element.id;
    var nextId = prefix + '-' + Math.random().toString(36).slice(2, 10);
    element.id = nextId;
    return nextId;
  }

  function hasExplicitLabel(field) {
    if (field.getAttribute('aria-label') || field.getAttribute('aria-labelledby')) return true;
    if (field.id && document.querySelector('label[for="' + field.id.replace(/"/g, '\\"') + '"]')) return true;
    return !!field.closest('label');
  }

  function isThemeOwnedElement(element) {
    if (!element) return false;
    var cursor = element;
    while (cursor && cursor !== document.body) {
      var marker = [
        cursor.id || '',
        cursor.className && typeof cursor.className === 'string' ? cursor.className : ''
      ].join(' ').toLowerCase();
      if (
        marker.indexOf('alia') !== -1 ||
        marker.indexOf('audioeye') !== -1 ||
        marker.indexOf('swym') !== -1 ||
        marker.indexOf('recharge') !== -1 ||
        marker.indexOf(' rc_') !== -1 ||
        cursor.hasAttribute('data-alia') ||
        cursor.hasAttribute('data-ae') ||
        cursor.hasAttribute('data-recharge')
      ) {
        return false;
      }
      cursor = cursor.parentElement;
    }
    return !!element.closest([
      '#PageContainer',
      'main',
      '.main-content',
      '#SiteHeader',
      '.site-header',
      '#HeaderCart',
      '.site-footer',
      '.grid-product',
      '.product-single__meta',
      '.collection-content',
      '.stamped-container'
    ].join(','));
  }

  function labelForField(field) {
    var placeholder = (field.getAttribute('placeholder') || '').replace(/\s+/g, ' ').trim();
    var fieldName = (field.getAttribute('name') || '').replace(/[[\]_-]+/g, ' ').trim();
    var fieldId = (field.id || '').replace(/[-_]+/g, ' ').trim();
    var context = '';
    if (field.closest('.rc-login, [class*="rc-"], [data-recharge]')) context = 'subscription ';
    if (field.closest('.cart__drawer-form, .cart')) context = 'cart ';
    if (field.type === 'email' || /email/i.test(fieldName + fieldId + placeholder)) return context + 'email address';
    if (field.type === 'search' || /search/i.test(fieldName + fieldId + placeholder)) return 'search';
    if (field.matches('[autocomplete="one-time-code"], [data-rc-code-input]')) return 'subscription verification code digit';
    if (field.matches('textarea[name="note"], #CartHeaderNote')) return 'cart order note';
    if (field.matches('select[name="SortBy"], #SortBy')) return 'sort products';
    if (/quantity|qty/i.test(fieldName + fieldId)) return 'quantity';
    if (placeholder) return placeholder;
    return humanizePathSegment(fieldName || fieldId) || 'form field';
  }

  function enhanceFormFieldNames() {
    document.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(function (field) {
      if (!isThemeOwnedElement(field)) return;
      if (hasExplicitLabel(field)) return;
      var labelText = labelForField(field);
      if (!labelText) return;
      field.setAttribute('aria-label', labelText);
      if (!field.id) ensureElementId(field, 'A11yField');
    });
  }

  function enhanceSvgNames() {
    document.querySelectorAll('svg').forEach(function (svg) {
      if (!isThemeOwnedElement(svg)) return;
      if (svg.getAttribute('aria-hidden') === 'true') return;
      if (svg.getAttribute('aria-label') || svg.getAttribute('aria-labelledby')) return;
      var owner = svg.closest('button, a[href]');
      var ownerText = getVisibleText(owner);
      if (owner && (ownerText || owner.getAttribute('aria-label') || owner.getAttribute('title'))) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('role', 'presentation');
        return;
      }
      var title = svg.querySelector('title');
      if (title && title.textContent.trim()) {
        var titleId = ensureElementId(title, 'A11ySvgTitle');
        svg.setAttribute('aria-labelledby', titleId);
      } else {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('role', 'presentation');
      }
    });
  }

  function labelForInteractive(element) {
    var visibleText = getVisibleText(element);
    if (visibleText) return visibleText;
    var img = element.querySelector('img[alt]');
    var imgAlt = img ? img.getAttribute('alt').trim() : '';
    if (imgAlt) return imgAlt;
    var title = element.getAttribute('title') || element.getAttribute('data-title') || '';
    if (title.trim()) return title.trim();
    var href = element.getAttribute('href') || '';
    if (href) {
      if (href.indexOf('/cart') !== -1) return 'Cart';
      if (href.indexOf('/account') !== -1) return 'Account';
      if (href.indexOf('/search') !== -1) return 'Search';
      return humanizePathSegment(href.split('/').filter(Boolean).pop());
    }
    if (element.matches('[data-predictive-search-button]')) return 'View more search results';
    if (element.matches('.js-toggle-submenu')) return 'Open menu';
    return '';
  }

  function enhanceButtonsAndLinks() {
    document.querySelectorAll('button, a[href]').forEach(function (element) {
      if (!isThemeOwnedElement(element)) return;
      if (element.matches('.grid-product__variant')) return;
      if (element.matches('button.video-play-overlay, button[id^="VideoOverlay"]')) return;
      var label = labelForInteractive(element);
      var currentLabel = element.getAttribute('aria-label') || '';
      if (!label && !currentLabel) return;
      if (!currentLabel) {
        element.setAttribute('aria-label', label);
        return;
      }
      if (label && currentLabel.toLowerCase().indexOf(label.toLowerCase()) !== 0) {
        var productTitle = getProductTitle(element);
        element.setAttribute('aria-label', productTitle && label.toLowerCase().indexOf(productTitle.toLowerCase()) === -1 ? label + ' - ' + productTitle : label);
      }
    });
  }

  function replaceDecorativeIconTags() {
    document.querySelectorAll('i.stamped-fa, i.fa, i.icon, i[class*="icon-"]').forEach(function (icon) {
      if (!isThemeOwnedElement(icon)) return;
      var span = document.createElement('span');
      Array.prototype.slice.call(icon.attributes).forEach(function (attribute) {
        span.setAttribute(attribute.name, attribute.value);
      });
      span.setAttribute('aria-hidden', 'true');
      span.setAttribute('role', 'presentation');
      span.innerHTML = icon.innerHTML;
      icon.parentNode.replaceChild(span, icon);
    });
  }

  var managedHiddenInteractiveRegions = new WeakSet();

  function syncHiddenInteractiveRegion(region) {
    if (!region || !region.matches) return;
    if (!region.matches('.slideshow__slide, .scrollable-grid--small')) {
      if (managedHiddenInteractiveRegions.has(region)) {
        region.removeAttribute('inert');
        managedHiddenInteractiveRegions.delete(region);
      }
      return;
    }
    if (region.getAttribute('aria-hidden') === 'true') {
      region.setAttribute('inert', '');
      managedHiddenInteractiveRegions.add(region);
    } else {
      region.removeAttribute('inert');
      managedHiddenInteractiveRegions.delete(region);
    }
  }

  function syncHiddenInteractiveRegions() {
    document.querySelectorAll('.slideshow__slide, .scrollable-grid--small').forEach(syncHiddenInteractiveRegion);
  }

  function runBroadA11yCleanup() {
    enhancePageTitle();
    enhanceFormFieldNames();
    enhanceSvgNames();
    enhanceButtonsAndLinks();
    enhanceCartLinkLabel();
    enhanceSearchComboboxes();
    enhanceProductCardActions();
    enhanceLandmarks();
    replaceDecorativeIconTags();
  }

  function applyReflowPatch() {
    if (document.getElementById('A11yReflowPatch')) return;
    var style = document.createElement('style');
    style.id = 'A11yReflowPatch';
    style.textContent = 'html{scroll-padding-top:110px}.grid-product__variant,.btn--secondary,.quick-add-btn,.js-qty__adjust,.js-qty__num,.collection-filter select,.collection-filter button,.filter-sort,input:not([type="hidden"]),select,textarea{border-color:#6b6b6b!important}.grid-product__variant.active,.grid-product__variant[aria-checked="true"]{border-color:#000!important}.grid-product__variant:focus-visible,.btn:focus-visible,a:focus-visible,button:focus-visible,input:focus-visible,select:focus-visible,textarea:focus-visible{outline:3px solid #4a4a4a!important;outline-offset:2px!important;scroll-margin-top:110px!important}@media screen and (max-width:480px){.collection-content .grid,.collection-content .grid--uniform,.collection-content .grid__item,.collection-filter,.collection-filter__item,.grid-product__actions,.grid-product__variants{max-width:100%;min-width:0}.collection-content .grid__item--sidebar,.collection-content .grid__item--content{width:100%!important;float:none!important}.grid-product__variants{display:flex;flex-wrap:wrap;gap:.35rem}.grid-product__variant{white-space:normal}.collection-sidebar{overflow-wrap:anywhere}.page-width{max-width:100%;box-sizing:border-box}}';
    document.head.appendChild(style);
  }

  ready(function () {
    ensureLiveRegion();
    restoreFocus();
    enhanceVideoButtons();
    enhanceStampedWidgets();
    observeStampedReviewFormExpandedState();
    enhanceWishlistFallback();
    enhanceCartDrawerFocus();
    enhanceProductMediaAlts();
    enhanceAccessibleNames();
    runBroadA11yCleanup();
    syncHiddenInteractiveRegions();
    applyReflowPatch();
    scheduleSearchComboboxRepair();

    document.addEventListener('focusin', function (event) {
      if (event.target && event.target.matches('.site-header__search-input, input[type="search"][name="q"]')) {
        enhanceSearchComboboxes();
      }
    });

    document.addEventListener('input', function (event) {
      if (event.target && event.target.matches('.site-header__search-input, input[type="search"][name="q"]')) {
        enhanceSearchComboboxes();
      }
    });

    var sortLabel = null;
    try {
      sortLabel = sessionStorage.getItem('a11ySortChanged');
      sessionStorage.removeItem('a11ySortChanged');
    } catch (error) {}
    if (sortLabel) announce('Products sorted by ' + sortLabel + '.');

    var observer = new MutationObserver(function () {
      enhanceVideoButtons();
      enhanceStampedWidgets();
      enhanceWishlistFallback();
      enhanceCartDrawerFocus();
      enhanceProductMediaAlts();
      enhanceAccessibleNames();
      runBroadA11yCleanup();
      syncHiddenInteractiveRegions();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var hiddenInteractiveRegionObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        syncHiddenInteractiveRegion(mutation.target);
      });
    });
    hiddenInteractiveRegionObserver.observe(document.body, { attributes: true, attributeFilter: ['aria-hidden', 'class'], subtree: true });
  });
})();
